export default "__VITE_ASSET__DGLzT7l$__"